import styled from "styled-components";
import { setFontVariant, colorsPalettes } from "@similarweb/styles";

export const StyledPreparingContainer = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    height: 393px;
    width: 475px;
`;

export const StyledMainText = styled.div`
    ${setFontVariant("listSectionTitle", colorsPalettes.carbon[500])}
`;

export const StyledHelpText = styled.div`
    margin-top: 8px;
    text-align: center;
    width: 318px;
    ${setFontVariant("listSectionTitle", colorsPalettes.carbon[400])}
`;
